/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';

// Component imports
import { Alert, Col, Row, Typography } from 'antd';
import { useBotLanguage } from '../../../utils/hooks/useBotLanguage';

/**
   * Renders a <Form.Item /> label and also the primary language text if the user is editing a secondary language
   * @param {String} label
   * @param {String} originalText
   * @param {String} tenantId //Needed for translations when tenantId is not provided in url params
   * @param {String} className //Pass custom style
   */
const LabelWithOriginalText = ({ label, originalText, tenantId, className = '' }) => {
  const { isEditingPrimaryLanguage } = useBotLanguage(tenantId);

  //Handle rendering of images in ReactMarkdown
  const imageRenderer = {
    img: ({ src, alt }) => (
      <img
        src={src}
        alt={alt || 'image'}
        className="h-auto"
        style={{ maxWidth: '100%' }} // Respect the container width
      />
    )
  };

  return (
    <Row className={`w-100 ${className}`}>
      {
        label ? (
          <Col span={24} className="mb-1">
            <Typography.Text>
              {label}
            </Typography.Text>
          </Col>
        ) : null
      }

      {
        !isEditingPrimaryLanguage ? (
          <Col span={24} className="mb-3">
            <Alert
              message={
                <Typography.Text>
                  <strong>Original text: </strong>
                  <ReactMarkdown
                    skipHtml
                    linkTarget="_blank"
                    className="mb-0"
                    components={imageRenderer}
                  >
                    {originalText || '(no text provided)'}
                  </ReactMarkdown>
                </Typography.Text>
              }
              className="border-0 bg-layout mix-blend-mode-multiply pt-3 pb-0"
            />
          </Col>
        ) : null
      }
    </Row>
  );
};

LabelWithOriginalText.propTypes = {
  label: PropTypes.string,
  originalText: PropTypes.string,
  tenantId: PropTypes.string,
  className: PropTypes.string
};

export default LabelWithOriginalText;

